import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | GradLink` : 'GradLink - Your Alumni Network, Reimagined';
    return () => { document.title = prev; };
  }, [title]);
};

export default usePageTitle;
